import { LitElement, html } from 'lit'

class TestimonialCard extends LitElement {
    // Use open DOM for Tailwind styling
    createRenderRoot() {
        return this
    }

    static properties = {
        name: { type: String },
        company: { type: String },
        role: { type: String },
        quote: { type: String },
        avatar: { type: String }
    }

    constructor() {
        super()
        this.name = ''
        this.company = ''
        this.role = ''
        this.quote = ''
        this.avatar = ''
    }

    render() {
        return html`
            <div class="card p-6 h-full flex flex-col">
                <!-- Quote -->
                <div class="flex-1 mb-6">
                    <div class="mb-4">
                        <sl-icon library="fa-solid" name="fa-quote-left" class="text-3xl text-primary-200 dark:text-primary-800"></sl-icon>
                    </div>
                    <blockquote class="text-gray-700 dark:text-gray-300 leading-relaxed italic">
                        "${this.quote}"
                    </blockquote>
                </div>

                <!-- Rating -->
                <div class="flex items-center space-x-1 mb-4">
                    ${Array.from({ length: 5 }, () => html`
                        <sl-icon library="fa-solid" name="fa-star" class="text-yellow-400 text-sm"></sl-icon>
                    `)}
                </div>

                <!-- Author Info -->
                <div class="flex items-center space-x-4">
                    <!-- Avatar -->
                    <div class="w-12 h-12 rounded-full overflow-hidden bg-gray-200 dark:bg-gray-700 flex-shrink-0">
                        ${this.avatar ? html`
                            <img 
                                src="${this.avatar}" 
                                alt="${this.name}"
                                class="w-full h-full object-cover"
                                @error="${this.handleImageError}">
                        ` : html`
                            <div class="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary-100 to-primary-200 dark:from-primary-800 dark:to-primary-900">
                                <sl-icon library="fa-solid" name="fa-user" class="text-xl text-primary-600 dark:text-primary-400"></sl-icon>
                            </div>
                        `}
                    </div>

                    <!-- Name and Company -->
                    <div class="flex-1 min-w-0">
                        <h4 class="font-semibold text-gray-900 dark:text-white truncate">
                            ${this.name}
                        </h4>
                        <p class="text-sm text-gray-600 dark:text-gray-400 truncate">
                            ${this.role}
                        </p>
                        <p class="text-sm text-primary-600 dark:text-primary-400 font-medium truncate">
                            ${this.company}
                        </p>
                    </div>
                </div>
            </div>
        `
    }

    handleImageError(event) {
        // Hide broken image and show fallback
        event.target.style.display = 'none'
        const fallback = event.target.nextElementSibling
        if (fallback) {
            fallback.style.display = 'flex'
        }
    }
}

customElements.define('testimonial-card', TestimonialCard)